var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.655,
    height: 16.654,
    viewBox: "0 0 16.655 16.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(-3043 -10958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectoricon-1",
    d: "M1.234,2.125a.891.891,0,1,1,.891-.891A.892.892,0,0,1,1.234,2.125Z",
    transform: "translate(3046.656 10961.656)",
    fill: "#9873a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectoricon",
    d: "M8.221.411a1.094,1.094,0,0,1,.774.321l7.746,7.746a1.086,1.086,0,0,1,0,1.55l-6.713,6.712a1.086,1.086,0,0,1-1.55,0L.732,8.995a1.094,1.094,0,0,1-.3-.984l1.2-5.991a.5.5,0,0,1,.393-.393L8.009.432A1.1,1.1,0,0,1,8.221.411ZM9.253,16.066a.084.084,0,0,0,.033-.007.086.086,0,0,0,.029-.019l0,0,6.717-6.717,0,0a.086.086,0,0,0,0-.123l0,0L8.287,1.439A.094.094,0,0,0,8.2,1.413L2.542,2.542,1.413,8.2a.093.093,0,0,0,0,.044.094.094,0,0,0,.023.039l7.749,7.749,0,0a.087.087,0,0,0,.062.026Z",
    transform: "translate(3042.589 10957.589)",
    fill: "#9873a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.fdd2304fd69b58f32b1b2c9a9018d09f.svg";
export { ForwardRef as ReactComponent };